// extracted by mini-css-extract-plugin
export default {"Drawer":"eujhXIu0","ContentRoot":"ojoMmoLL","header":"PMRZUYUk","footer":"ieyska31","content":"yKC_RJeK"};